import script from "./BillList.vue?vue&type=script&lang=ts&setup=true"
export * from "./BillList.vue?vue&type=script&lang=ts&setup=true"

import "./BillList.vue?vue&type=style&index=0&id=6baa5cd0&lang=scss&scoped=true"
import "./BillList.vue?vue&type=style&index=1&id=6baa5cd0&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6baa5cd0"]])

export default __exports__